export default __webpack_public_path__ + "static/media/matic.a3d0c752.svg";